import * as React from 'react'
import { fetchFullJson, UnauthorizedError, IEServiceError } from '@uhg-wviecp/dynamic-ui-shared/src/utils'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import * as actions from './redux/actions'
import { config } from '../config'
import { get, isPlainObject, find } from 'lodash'
import ReactMatomo from 'react-piwik'
const _ = { get, isPlainObject, find }

const isMatomoEnabled = (config.matomoUrl && config.matomoSiteId && process.env.NODE_ENV === 'production')

interface adminFetcherHOCProps {
  uuid: string
  locale: string
  accessToken: string
  location: {
    search: string
    pathname: string
  }
  logoutUser: (uuid: string, accessToken: string, skipRedirect: boolean) => void
}

interface adminFetcherHOCState {
}

const basePath = config.basePath

export function trackAPICall(url: string, request: {method?: any; headers?: any; body?: any; mode?: any;},
  businessCorrelationId: string, isSuccess: boolean, durationMillis: number) {
  // TODO: Should we only track Failure calls? Or make it toggleable?
  
  if (!isMatomoEnabled) {
    return;
  }
  const urlWithoutProtocol = url.replace('http://', '')
    .replace('https://', '')
  const pathName = urlWithoutProtocol.substring(urlWithoutProtocol.indexOf('/'))
  const dimensionKey = 'dimension' + config.matomoCustomDimensionCorrelationId
  const matomoParams: any[] = [
    'trackEvent',
    'Cor ID: ' + (businessCorrelationId ? businessCorrelationId : 'N/A'),
    (isSuccess ? 'Success' : 'Failure'),
    (request && request.method ? request.method : 'GET') + ' ' + pathName
  ]  
  matomoParams.push(durationMillis)
  if (businessCorrelationId) {      
    matomoParams.push({[dimensionKey]: businessCorrelationId})
  }
  ReactMatomo.push(matomoParams);
}

export const withAdminFetcher = WrappedComponent => {
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    class extends React.Component<adminFetcherHOCProps, adminFetcherHOCState> {
      constructor(props) {
        super(props)
        this.state = {
        }
      }

      adminFetch = (
        endpoint: string,
        request?: {
          method?: any
          headers?: any
          body?: any
          mode?: any
        },
        retries?: number,
        timeoutMs?: number
      ) => {
        const { uuid, accessToken, locale, logoutUser } = this.props
        const newHeaders = {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          locale: (locale + '_US').toUpperCase(),
          tenantCode: config.tenant.code,
          portalName: config.portalName,
          uuid,
          Authorization: accessToken ? `Bearer ${accessToken}` : '',
          ...(request.headers || {})
        }
        const newRequest = {
          ...request,
          headers: newHeaders,
          referrerPolicy: 'no-referrer-when-downgrade'
        }
        const beforeMillis = new Date().valueOf()
        
        return fetchFullJson(endpoint, newRequest, retries ? retries : 0, timeoutMs ? timeoutMs : 60000).then(response => {
          const durationMillis = new Date().valueOf() - beforeMillis
          if (response && _.isPlainObject(response)) {
            if (response.businessCorrelationId) {
              trackAPICall(endpoint, request, response.businessCorrelationId, true, durationMillis)
            } else {
              trackAPICall(endpoint, request, null, true, durationMillis)
            }
            if (typeof response.data !== 'undefined') {
              return response.data
            }
          }
          return response
        }).catch(
          error => {
            const durationMillis = new Date().valueOf() - beforeMillis
            if (error instanceof UnauthorizedError) {
              logoutUser(uuid, accessToken, false)
              trackAPICall(endpoint, request, null, false, durationMillis)
              //TODO: Trigger some kind of message to display?
            } else {
              if (error instanceof IEServiceError) {
                const { businessCorrelationId } = error as any
                trackAPICall(endpoint, request, businessCorrelationId, false, durationMillis)
              } else {
                trackAPICall(endpoint, request, null, false, durationMillis)
              }
              throw error
            }
          }
        )
      }

      render() {
        return <WrappedComponent {...this.props} adminFetch={this.adminFetch} />
      }
    }
  )
}

export const showError = (error, errorList, showErrorModal) => {
  let errorCode = _.get(error, `errorList[0].errorCode`)
  let errorObj = _.find(errorList, { LOOK_CD: errorCode });
  if (errorObj === undefined || errorObj.ERR_DESC === undefined) {
    showErrorModal("Something went wrong, please try again later.")
  } else {
    showErrorModal(errorObj.ERR_DESC)
  }
}

function mapStateToProps(state) {
  let uuid = _.get(state.auth, 'userAccount.uuid')
  let accessToken = _.get(state.auth, 'accessToken')
  return {
    uuid,
    locale: state.i18n.locale,
    accessToken
  }
}

function mapDispatchToProps(dispatch) {
  return {
    logoutUser: (uuid, accessToken, skipRedirect) => {
      dispatch(actions.logoutUser(uuid, accessToken, skipRedirect))
    }
  }
}
